"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _campaignState = require('web/screens/Broadcast/campaignState');
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');

var _Form = require('web/components/Form');
var _WizardFrame = require('../WizardFrame');
var _RecipientsScreen = require('web/screens/Broadcast/Recipients/RecipientsScreen'); var _RecipientsScreen2 = _interopRequireDefault(_RecipientsScreen);
var _AddRecipientsMenu = require('web/screens/Broadcast/Recipients/AddRecipientsMenu'); var _AddRecipientsMenu2 = _interopRequireDefault(_AddRecipientsMenu);
var _AddRecipientsDialogs = require('web/screens/Broadcast/Recipients/AddRecipientsDialogs'); var _AddRecipientsDialogs2 = _interopRequireDefault(_AddRecipientsDialogs);







/* Rev 31 v2: the create wizard's Recipients step. The shared recipients
 * screen under a title row with one Add button; Add saves straight to the
 * draft, so Continue only moves on to Message (once there's someone). */
const CampaignRecipients = ({ campaign, onBack, onContinue }) => {
  const [open, setOpen] = _react.useState(null)
  const onClose = _react.useCallback.call(void 0, () => setOpen(null), [])
  const onRemove = _react.useCallback.call(void 0, 
    (keys) => _actions2.default.removePatientsFromCampaign(campaign.CampaignKey, keys),
    [campaign.CampaignKey],
  )
  const hasRecipients = _campaignState.campaignRecipientCount.call(void 0, campaign) > 0
  // Decision 23: Continue opens once a background Add has started, before
  // its first rows land; sending waits for it to finish.
  const isAddingRecipients = _addingRecipients.useIsAddingRecipients.call(void 0, campaign.CampaignKey)
  const onAddFromCsv = _react.useCallback.call(void 0, () => setOpen('csv'), [])
  const menu = (
    _react2.default.createElement(_AddRecipientsMenu2.default, {
      label: "Add patients" ,
      campaignKey: campaign.CampaignKey,
      isDisabled: campaign.Archived,
      onAddExisting: () => setOpen('existing'),
      onAddFromCsv: onAddFromCsv, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
    )
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_WizardFrame.StepBody, { isWide: true, isFill: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , _react2.default.createElement('div', { className: "recipients-title-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          , _react2.default.createElement('h2', { className: "recipients-title-row--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "Who should get this campaign?"    )
          /* Q4: while the list is empty, the one Add is inside the table. */
          ,  hasRecipients && menu 
        )
        , _react2.default.createElement(_RecipientsScreen2.default, { campaign: campaign, emptyAction: menu, onAddFromCsv: onAddFromCsv, onRemovePatients: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}} )
      )
      , _react2.default.createElement(_WizardFrame.StepFooter, { isFullWidth: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "Back")
        , _react2.default.createElement('div', { className: "broadcast-wizard--foot-grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} )
        , _react2.default.createElement(_Form.Button, { isDisabled: !hasRecipients && !isAddingRecipients, onClick: onContinue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, "Continue")
      )
      , _react2.default.createElement(_AddRecipientsDialogs2.default, { campaign: campaign, open: open, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} )
    )
  )
}

exports. default = _react.memo.call(void 0, CampaignRecipients)
